import React, { useEffect } from "react";
import {
  Navbar,
  Hero,
  About,
  Skills,
  Portfolio,
  Contact,
  Footer,
} from "./components";
import { Helmet } from "react-helmet";

const App = () => {
  const callback = (entries) => {
    entries.forEach((entry) => {
      const elementDistanceFromTop = entry.target.getBoundingClientRect().top;

      if (
        elementDistanceFromTop <=
        (window.innerHeight || document.documentElement.clientHeight / 1.25)
      ) {
        entry.target.style.animation = entry.target.dataset.animate;
      } else {
        entry.target.style.animation = "none";
      }
    });
  };

  useEffect(() => {
    let observer = new IntersectionObserver(callback);

    const animationItems = document.querySelectorAll(".animate");

    animationItems.forEach((item) => {
      observer.observe(item);
    });
  }, []);

  return (
    <div id="home">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Trần Hữu Thắng - Mr.Katsu - Portfolio</title>
        <meta
          id="metaDescription"
          name="description"
          content="Trần Hữu Thắng - , website những dự án cá nhân  "
        />
        <meta
          property="og:description"
          content="Trần Hữu Thắng - , website những dự án cá nhân  "
        />
        <meta property="og:type" content="website dự án cá nhân" />
        <meta property="og:url" content="https://mrkatsu.tk/" />
        <link rel="canonical" href="https://mrkatsu.tk/" />
        <meta
          id="metaDescription"
          name="description"
          content="Mr.Katsu Trang Website dự án của Trần Hữu Thắng"
        />
        <meta
          property="og:description"
          content="Portfolio trang web cá nhân, Skill lập trình developer"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rikai-notes.tk/" />
      </Helmet>
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
